export default __webpack_public_path__ + "static/media/page3.25d6924e.png";